import { apiRequest } from '@/lib/api/client'

import { csChatSessionResponseSchema, type CsChatSessionResponse } from './schema'

export interface CsChatSessionPayload {
  channel: 'WEB'
  device_id: string
}

/**
 * Mint a customer service chat session token using authenticated account credentials.
 */
export async function fetchCsChatSession(deviceId: string): Promise<CsChatSessionResponse> {
  return apiRequest('/v1/account/cs-chat/session', {
    method: 'POST',
    schema: csChatSessionResponseSchema,
    body: {
      channel: 'WEB',
      device_id: deviceId,
    } satisfies CsChatSessionPayload,
  })
}
